<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Financial Year</h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3">
    <div class="col-md-10 offset-md-1" style="">
      <button id="addFyBtn" name="addFyBtn" mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add assignment" matTooltipPosition="left"
    (click)="openModal(modalContent,'add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Financial Year
    </button>
    </div>
  </div>
 
  <div class="pb-2 pt-2">
    <div class="col-md-12">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th scope="col">Sr.No.</th>
            <th scope="col">Name</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let modalFormObj of modalFormObjList; index as i" id="fy_{{i}}">
            <td scope="row">{{i+1}}</td>
            <td>{{modalFormObj.name}}</td>
            <td>{{modalFormObj.startDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{modalFormObj.endDate | date: 'dd-MMM-yyyy'}}</td>
            <td>
              <button id="editFyBtn_{{i}}" name="editFyBtn_{{i}}" class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,modalFormObj)"
              matTooltip="Click to edit" matTooltipPosition="above">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button> &nbsp;&nbsp;
              <button id="deleteFyBtn_{{i}}" name="deleteFyBtn_{{i}}" class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
              matTooltip="Click to delete" matTooltipPosition="above">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title">Financial Year</h5>
    </div>
    <div class="modal-body">

      <form [formGroup]="modalForm">
        <div class="row">
        <label class="col-sm-4">FY Name :</label>
        <div class="col-sm-8">
        <input id="name" name="name" type="text" class="form-control form-control-xs"
        formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted" matTooltip="{{formErrors.name}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        </div>
        </div>
        <div class="row">
        <label class="col-sm-4">Start Date :</label>
        <div class="col-sm-8">
        <div class="input-group" >
        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="startDate" ngbDatepicker
        #startDate="ngbDatepicker" formControlName="startDate" [placement]="'bottom'" [class.is-invalid]="formErrors.startDate && formSubmitted"
        matTooltip="{{formErrors.startDate}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        <div class="input-group-append">
        <button class="btn btn-outline-theme calendar" (click)="startDate.toggle()" type="button"></button>
        </div>
        </div>
        </div>
        </div>
        <div class="row">
        <label class="col-sm-4">End Date :</label>
        <div class="col-sm-8">
        <div class="input-group" >
        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="endDate" ngbDatepicker
        #endDate="ngbDatepicker" formControlName="endDate" [placement]="'bottom'" [class.is-invalid]="formErrors.startDate && formSubmitted"
        matTooltip="{{formErrors.startDate}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        <div class="input-group-append">
        <button class="btn btn-outline-theme calendar" (click)="endDate.toggle()" type="button"></button>
        </div>
        </div>
        </div>
        </div>
      </form>
    </div>
    <div class="modal-footer" style="">
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
              <button id="closeFyBtn" name="closeFyBtn" type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
          </div>
          <div class="col-sm-3">
              <button id="saveFyBtn" name="saveFyBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
              <button id="updateFyBtn" name="updateFyBtn" type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
          </div>
      </div>
    </div>
  </ng-template>
